import React from 'react';
import { Box, Card, CardContent, Chip, Typography } from '@mui/material';
import ReadingThumbnail from './ReadingThumbnail';
import { useTheme } from '@mui/material/styles';
import { SparkleIcon } from '@phosphor-icons/react';

interface ReadingTypeProps {
    item: {
        type: string;
        setup: number[];
        label: string;
        description: string;
        count: number;
        credits: number;
    };
    onReadingClick: () => void;
}

const ReadingType: React.FC<ReadingTypeProps> = ({ item, onReadingClick }) => {
    const theme = useTheme();

    return (
        <Card
            onClick={onReadingClick}
            sx={{
                position: 'relative',
                overflow: 'hidden',
                bgcolor: 'background.paper',
                display: 'flex',
                width: '100%',
                maxWidth: '600px',
                margin: '12px auto',
                borderRadius: 1,
                boxShadow: 1,
                cursor: 'pointer',
                transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: 2,
                },
                '&:active': {
                    transform: 'scale(0.99)',
                },
                '&::before': {
                    display: 'none'
                },
            }}
        >
            <Box display="flex" width="100%">
                <Box
                    mr={2}
                    flexShrink={0}
                    pl={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                >
                    <ReadingThumbnail
                        setup={item.setup}
                        type={item.type}
                        width="80px"
                        height={item.type === "horseshoe-spread" ? "120px" : "100px"}
                    />

                </Box>
                <Box flexGrow={1}>
                    <CardContent sx={{ flex: '1 0 auto', py: 2, pr: 2 }}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography
                                component="div"
                                variant="h6"
                                sx={{
                                    color: 'text.primary',
                                    fontWeight: 500,
                                    lineHeight: 1.4,
                                    fontSize: '1.1rem',
                                    fontFamily: theme.typography.fontFamily,
                                }}
                            >
                                {item.label}
                            </Typography>
                            <Chip
                                sx={{
                                    backgroundColor: theme.palette.text.tertiary,
                                    color: '#7A5E2F',
                                    fontFamily: theme.typography.fontFamily,
                                    fontSize: '0.65rem',
                                    height: '24px',
                                    borderRadius: '8px',
                                }}
                                label={
                                    <Box display="flex" alignItems="center" gap={0.5}>
                                        <span>{item.credits}</span>
                                        <SparkleIcon size={16} />
                                    </Box>
                                }
                            />
                        </Box>
                        <Typography
                            variant="body2"
                            component="div"
                            sx={{
                                color: 'text.secondary',
                                mt: 1,
                                fontFamily: theme.typography.fontFamily,
                            }}
                        >
                            {item.description}
                        </Typography>

                    </CardContent>
                </Box>
            </Box>
        </Card >
    );
};

export default ReadingType;
